(function (upp) {
    'use strict';

    var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE + "booking";

    upp.service('calendarUtil', [function () {
        var _weekDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'],
            _shortWeekDays = _weekDays.map(function (d) {
                return d + '_SHORT';
            }),
            _months = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER',
                'OCTOBER', 'NOVEMBER', 'DECEMBER'];

        /**
         * Splits an array into arrays of length 7
         * @param arr
         * @returns {Array}
         * @private
         */
        var _splitInChunksOfSeven = function (arr) {
            var result = [],
                tmp = [],
                count = 0;
            for (var i = 0; i < arr.length; i++) {
                tmp.push(arr[i]);

                if (++count === 7) {
                    result.push(angular.copy(tmp));
                    tmp = [];
                    count = 0;
                }
            }

            if (tmp.length > 0) {
                result.push(angular.copy(tmp));
            }

            return result;
        };

        /**
         * Generates an array with info about every day in the current month to render as the default calendar
         * @returns {Object}
         * @private
         */
        var _generateMonth = function (month, year) {
            if (month === undefined && year === undefined) {
                month = new Date().getMonth();
                year = new Date().getFullYear();
            }

            var _date = function (day) {
                    return new Date(year, month, day);
                },
                lastDay = new Date(year, month + 1, 0),
                days = [];

            for (var i = 1; i <= lastDay.getDate(); i++) {
                var day = _date(i);
                if (i === 1) {
                    var d = day.getDay();

                    if (d === 0) d = 7;

                    for (var j = 1; j < d; j++) {
                        days.push({
                            isEmpty: true,
                            day: '',
                            month: 0,
                            year: 0,
                            hasEvents: false,
                            isDisabled: false
                        });
                    }
                }

                days.push({
                    isEmpty: false,
                    day: day.getDate(),
                    month: day.getMonth(),
                    year: day.getFullYear(),
                    hasEvents: false,
                    isDisabled: false
                });
            }

            return {
                days: _splitInChunksOfSeven(days),
                monthDisabled: false,
                disabledDays: [false, false, false, false, false, false, false]
            };
        };

        return {
            weekDays: _weekDays,
            shortWeekDays: _shortWeekDays,
            months: _months,
            splitInChunksOfSeven: _splitInChunksOfSeven,
            generateMonth: _generateMonth
        };
    }]);

    upp.service('calendarService', ['appi', '$q', 'calendarUtil',
        function (appi, $q, calendarUtil) {

            /**
             * Return if the booking method is Upplication or external
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             * @private
             */
            var _getConfig = (function ($q, angular) {
                var calendars,
                    _copy = angular.copy;

                return function () {
                    var deferred = $q.defer();

                    if (calendars) {
                        deferred.resolve(calendars);
                    } else {
                        appi.http.get(URL_API_REST_SERVER + '/get')
                            .then(function (response) {
                                calendars = _copy(response.data) || [];
                                deferred.resolve(calendars);
                            }, function (err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                };
            })($q, angular);

            /**
             * Returns a list of selectable days with events and the configuration of the month for the current
             * calendar.
             *
             * @param id Calendar id
             * @param date Month and year for the calendar
             * @private
             */
            var _getMonthlyCalendar = function (id, date) {
                var deferred = $q.defer();

                if (!id) {
                    return calendarUtil.generateMonth(date.month, date.year);
                }

                appi.http.get(URL_API_REST_SERVER + '/calendar/' + id + '/for_date/' + date.year + '/'
                    + date.month)
                    .then(function (response) {
                        var result = angular.copy(response.data);
                        result.days = [];

                        for (var i = 0; i < response.data.days.length; i++) {
                            var day = new Date(response.data.days[i].day.replace('CEST ', '').replace('CET', '').replace('GMT', ''));

                            if (i === 0) {
                                var d = day.getDay();

                                if (d === 0) d = 7;

                                for (var j = 1; j < d; j++) {
                                    result.days.push({
                                        isEmpty: true,
                                        day: '',
                                        month: 0,
                                        year: 0,
                                        hasEvents: false,
                                        isDisabled: false
                                    });
                                }
                            }

                            result.days.push({
                                isEmpty: false,
                                day: day.getDate(),
                                month: day.getMonth(),
                                year: day.getFullYear(),
                                hasEvents: response.data.days[i].events > 0,
                                isDisabled: response.data.days[i]['restrictions'] > 0
                            });
                        }

                        result.days = calendarUtil.splitInChunksOfSeven(result.days);

                        deferred.resolve(result);
                    }, function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            };

            /**
             * Returns all intervals for the selected calendar and day
             * @param {number} calendar
             * @param {Object} date
             * @returns {Promise}
             * @private
             */
            var _getIntervals = function (calendar, date) {
                var deferred = $q.defer();

                if (calendar) {
                    appi.http.get(URL_API_REST_SERVER + '/calendar/' + calendar + '/intervals_for_date/' + date.year + '/'
                        + date.month + '/' + date.day)
                        .then(function (response) {
                            response.data['events'] = response.data['events'].map(function (e) {
                                e.interval = e.start + (e.end ? ' - ' + e.end : '');

                                return e;
                            });

                            deferred.resolve(response.data['events']);
                        }, function (err) {
                            deferred.reject(err);
                        });
                } else {
                    deferred.resolve([]);
                }

                return deferred.promise;
            };

            /**
             * Make a reservation
             * @param {Object} data
             * @private
             */
            var _makeReservation = function (data) {
                var deferred = $q.defer();

                appi.http.postSecure(URL_API_REST_SERVER + '/calendar/booking/new', data)
                    .then(function (response) {
                        deferred.resolve(response.data);
                    }, function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            };

            return {
                getConfig: _getConfig,
                getMonthlyCalendar: _getMonthlyCalendar,
                getIntervals: _getIntervals,
                makeReservation: _makeReservation
            };

        }]);

    upp.service('bookingsService', ['appi', '$q', function (appi, $q) {
        /**
         * List all user bookings
         * @returns {Promise}
         * @private
         */
        var _listBookings = function () {
            var deferred = $q.defer(), today = new Date();

            appi.http.getSecure(URL_API_REST_SERVER + '/calendar/bookings/mine')
                .then(function (response) {
                    var bookings = response.data['bookings'].map(function (b) {
                        var _h = b['hourStart'].split(':').map(function (o) {
                            return Number(o);
                        }), hour = _h[0], minutes = _h[1];


                        //FIXME: [310]Buscar una solución con angular
                        var dateArray = b.date.split('-');
                        b.date = new Date(dateArray[0],dateArray[1]-1,dateArray[2],0,0,0);

                        var dayArray = b.day.split('-');
                        var bookingTime = new Date(dayArray[0],dayArray[1]-1,dayArray[2],0,0,0);
                        bookingTime.setHours(hour);
                        bookingTime.setMinutes(minutes);

                        //FIN FIXME

                        b.past = bookingTime.getTime() < today.getTime();
                        return b;
                    });
                    deferred.resolve(bookings);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        /**
         * List all calendars with user reservations
         * @returns {Promise}
         * @private
         */
        var _listCalendars = (function ($q, angular) {
            var calendars,
                _copy = angular.copy;

            return function () {
                var deferred = $q.defer();

                if (calendars) {
                    deferred.resolve(calendars);
                } else {
                    appi.http.getSecure(URL_API_REST_SERVER + '/calendar/user_calendars')
                        .then(function (response) {
                            calendars = _copy(response.data)['calendars'] || [];
                            deferred.resolve(calendars);
                        }, function (err) {
                            deferred.reject(err);
                        });
                }

                return deferred.promise;
            };
        })($q, angular);

        /**
         * Cancels a booking
         * @param id
         * @returns {Promise}
         * @private
         */
        var _cancelBooking = function (id) {
            var deferred = $q.defer();

            appi.http.postSecure(URL_API_REST_SERVER + '/calendar/booking/cancel/' + id)
                .then(function (response) {
                    deferred.resolve(response.data.message);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        return {
            listBookings: _listBookings,
            listCalendars: _listCalendars,
            cancelBooking: _cancelBooking
        };
    }]);
})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/booking/services/booking-services.js